import { IAsyncState, IAsyncStateCreator } from "./types";

export function createIAsyncState<T = any>(data?: T): IAsyncStateCreator<T> {
    const state: IAsyncState<T> = {
        isRequesting: false,
        data: null,
        error: null,
        ...data
    };

    return {
        initial: () => ({ ...state }),
        requesting: (isRequesting: boolean = true) => ({ ...state, isRequesting }),
        success: (data: T) => ({ ...state, isRequesting: false, data }),
        failure: (error: any) => ({ ...state, isRequesting: false, error })
    };
}
